export default __webpack_public_path__ + "static/media/t8.bb9bb8ac.png";